// 1.Dependency
import {
    createRouter,
    // createWebHistory,
    createWebHashHistory,
} from "vue-router";
import { filter, flatten } from "lodash";
import { getUserInfo } from "@/service/account";
import store from "@/store";

// 2.Routes
const files = require.context("./", true, /\.js$/);
const routesModules = files.keys().reduce((modules, modulePath) => {
    const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, "$1");
    const value = files(modulePath);
    modules[moduleName] = value.default;
    return modules;
}, {});
const routes = [
    {
        path: "/",
        name: "index",
        component: () => import("@/views/Index.vue"),
    },
    ...flatten(
        filter(routesModules, (module) => {
            return module;
        })
    ),
    { path: "/:pathMatch(.*)*", name: "NotFound", component: () => import("@/views/_/NotFound.vue") },
    { path: "/forbidden", name: "NotAuthenticated", component: () => import("@/views/_/NotAuthenticated.vue") },
];

// 3.Build An Instance
const router = createRouter({
    history: createWebHashHistory(), //hash
    // history: createWebHistory(),  //history api
    // base : '/rewrite root',
    routes,
});

let userInfoLoadedToken = "";
function getTokenFromSearch() {
    try {
        return new URLSearchParams(window.location.search || "").get("token") || "";
    } catch (e) {
        return "";
    }
}

router.beforeEach(async (to) => {
    const cachedToken = localStorage.getItem("token") || "";
    const queryToken = to?.query?.token || "";
    const searchToken = getTokenFromSearch();
    const token = queryToken || cachedToken || searchToken;

    if (token && token !== cachedToken) {
        localStorage.setItem("token", token);
        store.commit("setToken", token);
    }

    if (!token || to.name === "profile") {
        return true;
    }

    let user = store.state.user || {};
    const hasUser = Object.keys(user).length > 0;
    const shouldFetchUser = !hasUser || userInfoLoadedToken !== token;

    if (shouldFetchUser) {
        try {
            const res = await getUserInfo(token);
            user = res?.data?.data || {};
            store.commit("SET_USER_INFO", user);
            userInfoLoadedToken = token;
        } catch (error) {
            userInfoLoadedToken = "";
            store.commit("logout");
            return { name: "NotAuthenticated" };
        }
    }

    if (!user.company || !user.name) {
        return { name: "profile", query: { redirect: to.fullPath === "/" ? "/apply" : to.fullPath } };
    }

    if (to.name === "index") {
        return { name: "user_info" };
    }

    return true;
});

export default router;
